module.exports = __webpack_public_path__ + "static/media/008.22e15337.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/normals/008.jpg
// module id = 481
// module chunks = 0